import { Droplet } from "lucide-react";

export const WaterIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.7625 15.6219C20.7625 11.4054 14.1076 3.42093 13.3539 2.52358C12.9559 2.04943 12.1431 2.04943 11.7367 2.52358C10.9747 3.42104 4.32812 11.4055 4.32812 15.6219C4.32812 20.1517 8.01123 23.8346 12.5495 23.8346C17.0878 23.8346 20.7709 20.1515 20.7709 15.6219H20.7625ZM6.44492 15.6219C6.44492 13.048 10.3143 7.68011 12.5497 4.8775C14.785 7.68005 18.6546 13.048 18.6546 15.6219C18.6546 18.9832 15.9197 21.7181 12.5497 21.7181C9.17974 21.7181 6.44492 18.9832 6.44492 15.6219Z"
        fill={color}
      />
      <path
        d="M17.4704 15.6208C17.4704 15.0366 16.9963 14.5625 16.4121 14.5625C15.8279 14.5625 15.3537 15.0366 15.3537 15.6208C15.3537 17.1703 14.0922 18.4234 12.5427 18.4234C11.9585 18.4234 11.4844 18.8975 11.4844 19.4817C11.4844 20.0659 11.9585 20.5401 12.5427 20.5401C15.2606 20.5401 17.4704 18.3302 17.4704 15.6208Z"
        fill={color}
      />
    </svg>
    // <Droplet
    //   stroke="var(--color-planet-green)"
    //   strokeWidth={1.5}
    // />
  );
};

export default WaterIcon;
